// extracted by mini-css-extract-plugin
export default {"bold":"VideoCard_bold__er3FW","description":"VideoCard_description__hENux","badge":"VideoCard_badge__6AQXB"};